import { PDFViewer } from "pdfjs-dist/web/pdf_viewer";

type Coordinate = { x: number; y: number };

export const getBoundingRect = (start: Coordinate, end: Coordinate) => {
  return {
    left: Math.min(end.x, start.x),
    top: Math.min(end.y, start.y),
    width: Math.abs(end.x - start.x),
    height: Math.abs(end.y - start.y),
  };
};

export const getRectangle = (start: Coordinate, end: Coordinate) => {
  return {
    x1: Math.min(start.x, end.x),
    y1: Math.min(start.y, end.y),
    x2: Math.max(start.x, end.x),
    y2: Math.max(start.y, end.y),
  };
};

export const getPageFromElement = (target: HTMLElement) => {
  const node = target.closest(".page");

  if (!(node instanceof HTMLElement)) {
    return null;
  }

  const number = Number(node.dataset.pageNumber);

  return { node, number };
};

export const findOrCreateContainerLayer = (
  container: HTMLElement,
  className: string
) => {
  let layer = container.querySelector(`.${className}`);

  if (!layer) {
    layer = document.createElement("div");
    layer.className = className;
    container.appendChild(layer);
  }

  return layer;
};

export const findOrCreateAnnotationLayer = (
  container: PDFViewer,
  page: number
) => {
  const pageView = container.getPageView(page - 1);

  if (!pageView || !pageView.textLayer) {
    return null;
  }

  const textLayer = pageView.textLayer;

  return findOrCreateContainerLayer(
    textLayer.textLayerDiv,
    "PdfHighlighter__highlight-layer"
  );
};
